module.exports = __webpack_public_path__ + "static/deals-6204e75573ec7e0d50277e6fc9d7762c.png";